<template>
    <div class="components-feature-box">
        <div class="box-title">
            <img :src="props.data.icon" alt="" />
            <div class="text">{{props.data.title }}</div> 
        </div>
        <div class="box-list">
            <div class="list-item" v-for="item in props.data.list" :key="item.title">
                <div class="item-title">
                    <img :src="item.icon" alt="" />
                    <div class="text">{{item.title}}</div>
                </div>
                <div class="item-content" v-html="item.desc"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
</script>

<style lang="scss" scoped>
.components-feature-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 56px;
    .box-title{
        display: flex;
        align-items: center;
        img{
            width: 22px;
            height: 22px;
        }
        .text{
            color: rgb(38, 38, 38);
            font-family: 阿里巴巴普惠体 2.0;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 0px;
            margin-left: 12px;
        }
    }
    .box-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 24px;
        .list-item{
            width: 100%;
            padding: 24px;
            border-radius: 8px;
            background: rgb(255, 255, 255);
            display: flex;
            flex-direction: column;
            margin-bottom: 18px;
            .item-title{
                display: flex;
                align-items: center;
                img{
                    width: 14px;
                    height: 12px;
                }
                .text{
                    color: rgb(30, 89, 191);
                    font-family: 阿里巴巴普惠体 2.0;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 20px;
                    letter-spacing: 0px;
                    margin-left: 6px;
                }
            }
            .item-content{
                color: rgb(38, 38, 38);
                font-family: 阿里巴巴普惠体 2.0;
                font-size: 12px;
                font-weight: 300;
                line-height: 24px;
                letter-spacing: 0px;
                margin-top: 12px;
                text-align: justify;
            }
            &:last-child{
                margin-bottom: 0px;
            }
        }
    }
}
</style>
